import { TEMPLATE_ROUTE_ID } from './common';
import TemplateManagement from './components/TemplateManagement';

const routes = {
    [TEMPLATE_ROUTE_ID]: () => <TemplateManagement />
};

export default routes;
